import React from 'react';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import SoftwareProducts from '../components/sections/SoftwareProducts';
import BlogPreview from '../components/sections/BlogPreview';

const HomePage: React.FC = () => {
  return (
    <main>
      <Hero />
      <About />
      <SoftwareProducts />
      <BlogPreview />
      {/* <Contact /> */}
    </main>
  );
};

export default HomePage;
